// extracted by mini-css-extract-plugin
export default {"statusCell":"xkxvxjrMy1fUAKmqg6cj","cancelledStatus":"KMrlein_47JZKSZumgbf","cancelledStatusDescription":"H5A27vUm9dfTeYvxKWpN"};